import React from "react";
import { useTranslation } from "react-i18next";

const videoStyle = {
  width: "100%",
  height: "200px",
  border: "none",
  borderRadius: "8px",
};

const IndiaAIFestivalProjectShowcase = ({ year }) => {
  const { t } = useTranslation();
  return (
    <div className="project-showcase mb-3 mb-md-5">
      <h3>{t("impact_festival_2025.project_showcase_title")}</h3>

      <div className="row mb-4">
        <div className="col-md-6 mb-4 mb-md-0 text-center">
          <div className="mb-2">
            <iframe
              style={videoStyle}
              src="https://www.youtube.com/embed/Kimex5YZai4"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              title="YouTube video 1"
            />
          </div>
          <a
            href="/assets/pdf/sporty-coach-2-arjun-manocha.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary"
          >
            <h5 className="mb-1">
              {t(`impact_festival_2025.project_showcase_pdf_text_1`)}
            </h5>
          </a>
        </div>

        <div className="col-md-6 text-center">
          <div className="mb-2">
            <iframe
              style={videoStyle}
              src="https://www.youtube.com/embed/vkDQqahsR6A"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              title="YouTube video 2"
            />
          </div>
          <a
            href="/assets/pdf/digifriend-aadit-kashyap-dpsn-std.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary"
          >
            <h5 className="mb-1">
              {t(`impact_festival_2025.project_showcase_pdf_text_2`)}
            </h5>
          </a>
        </div>
      </div>
    </div>
  );
};

export default IndiaAIFestivalProjectShowcase;
